import { configureStore } from "@reduxjs/toolkit"
import organizationReducer from "./slices/organizationSlice"
import userGroupReducer from "./slices/userGroupSlice"
import usersReducer from "./slices/usersSlice"
import simulatorApplicationReducer from "./slices/simulatorApplicationSlice"
import trainingModuleReducer from "./slices/trainingModuleSlice"
import chapterReduced from "./slices/chapterSlice"
import lessonReduced from "./slices/lessonSlice"
import licensePoolReducer from "./slices/licensePoolSlice"
import licenseReducer from "./slices/licenseSlice"
import deviceReducer from "./slices/deviceSlice"
import trainingReportReducer from "./slices/trainingReportSlice"

export const store = configureStore({
  reducer: {
    organization: organizationReducer,
    usergroup: userGroupReducer,
    users: usersReducer,
    simulatorapplication: simulatorApplicationReducer,
    trainingmodule: trainingModuleReducer,
    chapter: chapterReduced,
    lesson: lessonReduced,
    licensepool: licensePoolReducer,
    license: licenseReducer,
    device: deviceReducer,
    trainingreport: trainingReportReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
